<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import Vue from "vue";
import excel from "vue-excel-export";
Vue.use(excel);

export default {
  page: {
    title: "Fees Settings",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Fees Settings",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Fees",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "fee",
          label: "Fee",
          sortable: true,
        },
        {
          key: "class",
          label: "Course",
          sortable: true,
        },
        {
          key: "amount_field",
          label: "Amount",
          sortable: true,
        },
        {
          key: "term_field",
          label: "Level/Grade",
          sortable: true,
        },
        {
          key: "year",
          label: "Year",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        fee: "",
        amount: "",
        level: "",
        year: moment(new Date()).format("YYYY"),
        class: "",
      },
      deletedata: {
        name: "",
        class: "",
        level: "",
        id: "",
      },
      editdata: {
        name: "",
        class: "",
        fee: "",
        amount: "",
        level: "",
        year: "",
        id: "",
      },
      feeError: "",
      classError: "",
      levelError: "",
      amountError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("classes", [
      "AllClasses",
      "SaveStatus",
      "CustomClasses",
      "AllCourses",
    ]),
    ...mapGetters("fees", ["FeesItems", "FeesSettings", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    ...mapGetters("marks", ["getYears"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.FeesSettings ? this.FeesSettings.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.FeesSettings ? this.FeesSettings.length : 1;
  },
  methods: {
    ...mapActions({
      FetchCourses: "classes/fetchCourses",
      FetchCustomClasses: "classes/fetchCustomClasses",
      FetchFeesItems: "fees/fetchItems",
      FetchFeesSettings: "fees/fetchFeesSettings",
      AddSetting: "fees/addFeesSetting",
      EditSetting: "fees/editFeesSetting",
      DeleteSetting: "fees/deleteFeesSetting",
      FetchYears: "marks/fetchYear",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.FeesSettings ? this.FeesSettings.length : 1;
      this.currentPage = 1;
    },

    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addCommas() {
      this.data.amount = this.thousandSeperater(this.data.amount);
    },

    resetError() {
      this.feeError = "";
      this.amountError = "";
      this.levelError = "";
      this.classError = "";
    },

    resetAddModal() {
      this.data.class = "";
      this.data.fee = "";
      this.data.amount = "";
      this.data.level = "";
      this.resetError();
    },
    resetEditModal() {
      this.editdata.fee = "";
      this.editdata.class = "";
      this.editdata.level = "";
      this.editdata.amount = "";
      this.editdata.id = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.class = "";
      this.deletedata.level = "";
      this.deletedata.id = "";
    },

    addSetting(modal) {
      if (this.data.fee == "") {
        this.feeError = "Fees Item is required";
        return;
      } else {
        this.feeError = "";
      }
      if (this.data.class == "") {
        this.classError = "Class field can't be empty";
        return;
      } else {
        this.classError = "";
      }
      if (this.data.amount == "") {
        this.amountError = "Item amount is required";
        return;
      } else {
        this.amountError = "";
      }
      if (this.data.level == "") {
        this.levelError = "Level field can't be empty";
        return;
      } else {
        this.levelError = "";
      }
      this.modal = modal;
      this.AddSetting(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.fee = values.item.fee;
      this.editdata.class = values.item.class;
      this.editdata.amount = values.item.amount;
      this.editdata.level = values.item.level;
      this.editdata.year = values.item.year;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.fee;
      this.deletedata.class = values.item.class;
      this.deletedata.level = values.item.level;
    },
    deleteSetting(modal) {
      this.modal = modal;
      this.DeleteSetting(this.deletedata);
      this.closeModal(modal);
    },
    editSetting(modal) {
      if (this.editdata.fee == "") {
        this.feeError = "Fee name is required";
        return;
      } else {
        this.feeError = "";
      }
      if (this.editdata.amount == "") {
        this.amountError = "Amount field can't be empty";
        return;
      } else {
        this.amountError = "";
      }
      this.modal = modal;
      this.EditSetting(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    fetchLevelinCourse() {
      const courseSelected = {
        course: this.data.class,
      };
      //fetching levels in course
      this.FetchCustomClasses(courseSelected);
    },
  },
  created() {
    this.FetchFeesItems();
    this.FetchCourses();
    this.FetchFeesSettings();
    this.FetchYears();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_fees_settings')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  Fees Structures For All Courses
                </h3>
              </div>
              <div class="col-3">
                <!-- <select
                  class="form-control form-control-sm"
                  required
                  v-model="filterData.year"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Year</option>
                  <option
                    v-for="(schyear, index) in getYears"
                    :value="schyear.year"
                    :key="index"
                  >
                    {{ schyear.year }}
                  </option>
                </select> -->
                <button
                  v-b-modal.add-setting-modal
                  class="btn btn-sm btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_fees_settings')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add Fee
                </button>
                <export-excel :data="FeesSettings" name="Fees Breakdowns.xls">
                  <b-btn variant="success" class="btn-sm">
                    <i class="fa fa-download"></i>
                    Excel
                  </b-btn>
                </export-excel>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="FeesSettings ? FeesSettings : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(amount_field)="data">
                  {{ data ? thousandSeperater(data.item.amount) : "---" }}
                </template>
                <template #cell(term_field)="data">
                  {{ data ? data.item.level : "---" }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <button
                      class="btn btn-outline-primary btn-sm"
                      v-b-modal.edit-setting-modal
                      @click="showEditModal(data)"
                    >
                      <i class="fa fa-edit"></i> Edit
                    </button>
                    <button
                      class="btn btn-outline-danger btn-sm"
                      v-b-modal.delete-setting-modal
                      @click="showDeleteModal(data)"
                    >
                      <i class="fa fa-trash"></i> Delete
                    </button>
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-setting-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_fees_settings')
          )
        "
      >
        <template #modal-title> Set New Fee</template>
        <div class="row">
          <div class="form-group">
            <label class="col-form-label">Fee Type</label>
            <input
              v-model="data.fee"
              class="form-control"
              list="fee"
              placeholder="Enter Fee"
              autocomplete="off"
              @input="resetError()"
            />
            <datalist id="fee">
              <option
                v-for="(fee, v) in FeesItems"
                :data-value="fee.id"
                :key="v"
              >
                {{ fee.name }}
              </option>
            </datalist>
            <div class="text-danger" v-if="feeError">
              <em>{{ feeError }}</em>
            </div>
          </div>
          <div class="form-group">
            <label class="col-form-label">Amount</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Fee Amount"
                class="form-control"
                @input="resetError(), addCommas()"
                v-model="data.amount"
              />
            </div>
            <div class="text-danger" v-if="amountError">
              <em>{{ amountError }}</em>
            </div>
          </div>
          <div class="form-group">
            <label class="col-form-label">Courses</label>
            <div class="input-group">
              <select
                required
                v-model="data.class"
                class="form-control"
                @change="fetchLevelinCourse(), resetError()"
              >
                <option v-if="SaveStatus" selected value="" disabled>
                  Fetching Courses...
                </option>
                <option v-else selected value="" disabled>
                  Select Course
                </option>
                <option
                  v-for="(course, index) in AllCourses"
                  :key="index"
                  :value="course.id"
                >
                  {{ course.name }}
                </option>
              </select>
            </div>
            <div class="text-danger" v-if="classError">
              <em>{{ classError }}</em>
            </div>
          </div>
          <div class="form-group">
            <label class="col-form-label">Entry Level/Grade</label>
            <div class="input-group">
              <select required v-model="data.level" class="form-control">
                <option v-if="SaveStatus" selected value="" disabled>
                  Fetching Levels...
                </option>
                <option v-else selected value="" disabled>
                  Select Level
                </option>
                <option
                  v-for="(classes, index) in CustomClasses"
                  :key="index"
                  :value="classes.id"
                >
                  {{ classes.short }}
                </option>
              </select>
            </div>
            <div class="text-danger" v-if="levelError">
              <em>{{ levelError }}</em>
            </div>
          </div>

          <div class="form-group">
            <label class="col-form-label">Year</label>
            <div class="input-group">
              <input type="number" class="form-control" v-model="data.year" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-setting-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="addSetting('add-setting-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal id="edit-setting-modal" hide-footer @hidden="resetEditModal()">
        <template #modal-title>
          Edit Setting for {{ editdata.fee }} ({{ editdata.class }} :
          {{ editdata.level }})</template
        >
        <div class="row">
          <div class="form-group">
            <label class="col-form-label">Fee Type</label>
            <input
              v-model="editdata.fee"
              class="form-control"
              list="fee"
              placeholder="Enter Fee"
              autocomplete="off"
              @input="resetError()"
            />
            <datalist id="fee">
              <option
                v-for="(fee, v) in FeesItems"
                :data-value="fee.id"
                :key="v"
              >
                {{ fee.name }}
              </option>
            </datalist>
          </div>
          <div class="text-danger" v-if="feeError">
            <em>{{ feeError }}</em>
          </div>
          <div class="form-group">
            <label>Amount</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Fee Amount"
                class="form-control"
                @input="resetError(), addCommas()"
                v-model="editdata.amount"
              />
            </div>
            <div class="text-danger" v-if="amountError">
              <em>{{ amountError }}</em>
            </div>
          </div>
          <div class="form-group">
            <label>Year</label>
            <div class="input-group">
              <input
                type="number"
                class="form-control"
                v-model="editdata.year"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-setting-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="editSetting('edit-setting-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete setting starts -->
      <b-modal id="delete-setting-modal" hide-footer @hidden="resetDeleteModal">
        <template #modal-title>
          <h4 class="text-danger">
            Delete {{ deletedata.name }} From {{ deletedata.class }} :
            {{ deletedata.level }}
          </h4>
        </template>
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete {{ deletedata.name }} From
              {{ deletedata.class }}? Click Proceed Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-setting-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="deleteSetting('delete-setting-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
